module.exports = __webpack_public_path__ + "static/media/payment_successful.jpg";